import { render, staticRenderFns } from "./index-category.vue?vue&type=template&id=d9c8a088&scoped=true&"
import script from "./index-category.vue?vue&type=script&lang=js&"
export * from "./index-category.vue?vue&type=script&lang=js&"
import style0 from "./index-category.vue?vue&type=style&index=0&id=d9c8a088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c8a088",
  null
  
)

export default component.exports